import { i18n as _i18n } from "@lingui/core";
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const TermsAndConditions = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "tos",
    children: /*#__PURE__*/_jsx("p", {
      dangerouslySetInnerHTML: {
        __html: _i18n._(
        /*i18n*/
        {
          id: 'carleadCreation.form.legal',
          message: "Mit Anforderung der Online-Bewertung erkl\xE4ren Sie sich mit den \n              <a href='/agb/'>AGB</a>\n              und der<a href='/datenschutz/'>Datenschutzerkl\xE4rung</a> einverstanden."
        })
      }
    })
  });
};
export default TermsAndConditions;